/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { RestService } from '../../RestService';

class ActionRequestServiceLevelService extends RestService {
    /** @ngInject */
    constructor($q, resource, $httpParamSerializerJQLike, $log) {
        super($q, resource,  $httpParamSerializerJQLike, $log, false);
        $log.debug('Service \'Service Level\' loaded');
    }
}

export { ActionRequestServiceLevelService };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/actionrequest/service/ActionRequestServiceLevelService.js